/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Row, Col, Tooltip, Empty } from 'antd';
import { Link } from 'react-router-dom';
import Translated from 'components/Translated';

const FavoritesOrder = ({ userData, deleteFavorisOrder }) => {
    function handleDeleteFavoris(fav) {
        const delFavoris = {
            user_id: userData._id,
            order_number: fav,
        };
        deleteFavorisOrder(delFavoris);
    }

    return (
        <Row align="middle" gutter={8}>
            <Col>
                {
                    userData.favorite_orders && userData.favorite_orders.length !== 0
                        ? userData.favorite_orders.slice(0, 10).map(fav => (
                            <div key={fav}>
                                <span><Translated id="global.order" />:&nbsp;</span>
                                <Link
                                    key={fav}
                                    to={`/crm/orders/view/${fav}`}
                                    target="_blank"
                                >{fav}
                                </Link>
                                <Tooltip title={<Translated id="global.delete" />}>
                                    <button style={{ color: 'red' }} type="button" className="gx-buttonless" onClick={() => handleDeleteFavoris(fav)}>
                                        <i className="la la-trash la-lg" />
                                    </button>
                                </Tooltip>
                            </div>
                        )) : <Empty />
                }
            </Col>
        </Row>
    );
};

export default FavoritesOrder;
